import product1 from '../../images/product-1.jpg';
import product2 from '../../images/product-2.jpg';
import product3 from '../../images/product-3.jpg';
import snack1 from '../../images/snack-1.jpg';
import snack2 from '../../images/snack-2.jpg';
import snack3 from '../../images/snack-3.jpg';

export const productData = [
    {
        img: product1,
        alt: 'Doughnut',
        name: 'Supreme Doughnut',
        desc: 
           'Oily, spicy, jam and pesto',
        price: '$19.99',
        button: 'Add to Cart'
    },
    {
        img: product2,
        alt: 'Meatpie',
        name: 'Hawaiian Pie',
        desc: 
          'Oily, spicy, meaty and pesto',
        price: '$16.99',
        button: 'Add to Cart'
    },
    {
        img: product3,
        alt: 'Shawarma',
        name: 'Veggie Shawarma',
        desc: 
          'Oily, spicy, salad, sausage',
        price: '$14.99',
        button: 'Add to Cart'
    }
];

export const productDataTwo = [
    {
        img: snack1,
        alt: 'Eggroll',
        name: 'Egg Roll',
        desc: 
           'Oily, spicy, jam and pesto',
        price: '$17.99',
        button: 'Add to Cart'
    },
    {
        img: snack2,
        alt: 'Sausage',
        name: 'Sausage',
        desc: 
          'Oily, spicy, meaty and pesto',
        price: '$15.99',
        button: 'Add to Cart'
    },
    {
        img: snack3,
        alt: 'fishpie',
        name: 'Fish Pie',
        desc: 
          'Oily, spicy, salad, sausage',
        price: '$10.99',
        button: 'Add to Cart'
    }
];